var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[(_vm.status.type)?_c('div',{class:`status-dot status-dot--${_vm.status.type}`}):_vm._e(),(_vm.status.label)?_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.status.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }